import { TimePeriod } from '../../../model/CORE';
import AppContext from '../../../common/context/AppContext';

export class ScenarioUtils {
    public static getDefaultScenarioTimePeriod(): TimePeriod {
        let fromTime = AppContext.getCurrentTime();
        if (fromTime.getMinutes() > 30) {
            fromTime.setHours(fromTime.getHours() + 1);
        }
        fromTime.setMinutes(0, 0, 0);
        fromTime.setHours(fromTime.getHours() + 3);
        const toTime = AppContext.getMonitoringPeriod().to;

        if (fromTime.getTime() >= toTime.getTime()) {
            fromTime = new Date(toTime.getTime() - 60 * 60 * 1000);
        }

        return {
            from: fromTime,
            to: toTime,
        };
    }
}
